import autoszervizImg from "@/assets/services/autoszerviz-javitas-eger.webp";
import fekjavitasImg from "@/assets/services/fekjavitas-fektarcsa-csere-eger.webp";
import futomuImg from "@/assets/services/futomu-javitas-lengokar-eger.webp";
import motorfelujitasImg from "@/assets/services/motorfelujitas-motorjavitas-eger.webp";
import muszakiVizsgaImg from "@/assets/services/muszaki-vizsga-felkeszites-eger.webp";
import gumiszerelesImg from "@/assets/services/gumiszereles-centrirozas-eger.webp";
import motorkerekparImg from "@/assets/services/motorkerekpar-szerviz-eger.webp";

export interface ServiceContent {
  slug:
    | "autoszerviz-eger"
    | "fekjavitas-eger"
    | "futomu-javitas-eger"
    | "motorfelujitas-eger"
    | "muszaki-vizsga-felkeszites-eger"
    | "gumiszereles-eger"
    | "motorkerekpar-szerviz-eger";
  cardTitle: string;
  cardDesc: string;
  h1: string;
  metaTitle: string;
  metaDescription: string;
  intro: string;
  image: string;
  imageAlt: string;
  symptoms: { title: string; text: string }[];
  symptomsTitle?: string;
  what: string[];
  whatTitle?: string;
  workflow: { step: string; text: string }[];
  faqs: { q: string; a: string }[];
  closing: string;
  relatedServiceSlugs?: ServiceContent["slug"][];
}

export const SERVICES: ServiceContent[] = [
  {
    slug: "autoszerviz-eger",
    cardTitle: "Autószerviz Eger",
    cardDesc: "Általános autószerviz, olajcsere, hibafeltárás és karbantartás Egerben.",
    h1: "Autószerviz Eger – LAKROSZ Autószerviz",
    metaTitle: "Autószerviz Eger | LAKROSZ – Megbízható autójavítás Egerben",
    metaDescription:
      "Márkafüggetlen autószerviz Egerben. Olajcsere, számítógépes diagnosztika, általános karbantartás — gyorsan, átlátható áron. Hívjon most: +36 30 478 7619.",
    image: autoszervizImg,
    imageAlt:
      "Autószerviz Eger – szerelő villáskulccsal dolgozik a nyitott motortérben a LAKROSZ műhelyében",
    intro:
      "A LAKROSZ Autószerviz Egerben, a Vécseyvölgy utca 99. szám alatt működik, és teljes körű autószerviz szolgáltatást nyújt személyautókra és kishaszon-gépjárművekre, márkától függetlenül. Az olajcserétől a komplex hibafeltáráson át a futómű- és motorjavításig egy helyen, átlátható árazással és valódi szakmai háttérrel dolgozunk. Eger és vonzáskörzete (Felsőtárkány, Egerszalók, Andornaktálya, Maklár, Noszvaj, Ostoros) ügyfeleinek is gyors, kiszámítható időpontokat tudunk biztosítani.",
    symptoms: [
      {
        title: "Furcsa hangok vagy rezgések menet közben",
        text: "Ha az autó kanyarodáskor kattog, fékezéskor rezeg vagy gyorsításkor zörög, érdemes szervizbe vinni, mielőtt a hiba komolyabbra fordulna.",
      },
      {
        title: "Műszerfali kijelző hibajelzések",
        text: "A motorhiba, ABS, ESP vagy akkumulátortöltés lámpák bekapcsolása mindig konkrét, diagnosztikával beazonosítható okra utal.",
      },
      {
        title: "Megnövekedett fogyasztás vagy gyengébb teljesítmény",
        text: "Egy elhasználódott gyertya, eltömődött szűrő vagy hibás lambdaszonda akár 10–20% pluszfogyasztást is okozhat.",
      },
      {
        title: "Olajfolyás vagy szokatlan szag",
        text: "Az alvázon megjelenő foltok és az égett szag rendszerint tömítés- vagy hűtésrendszeri problémát jeleznek.",
      },
    ],
    what: [
      "Általános karbantartás, olaj- és szűrőcserék (motorolaj, levegő-, pollen-, üzemanyagszűrő).",
      "Számítógépes hibakód-olvasás és diagnosztika minden gyakori márkára.",
      "Fék-, futómű- és kipufogórendszer javítása.",
      "Motor- és váltójavítás, vezérlésjavítás, szíjcserék.",
      "Klímatisztítás és klímatöltés, akkumulátor csere.",
      "Műszaki vizsga előtti átvizsgálás és felkészítés.",
    ],
    workflow: [
      {
        step: "1. Időpontegyeztetés és előzetes felmérés",
        text: "Telefonon vagy e-mailben részletesen végigbeszéljük a panaszokat, az autó márkáját, évjáratát és futásteljesítményét, hogy már érkezés előtt felkészülhessünk a megfelelő műszerekkel és alkatrészekkel. Olyan időpontot adunk, ami valóban tartható – nem heteket kell várni, és ha sürgős az ügy, igyekszünk még aznap vagy másnap beállítani a járművet.",
      },
      {
        step: "2. Pontos diagnosztika több szinten",
        text: "Modern diagnosztikai műszerekkel és tapasztalt szerelői szemmel keressük meg a hiba valódi okát, nem csupán a tünetet kezeljük. Először hibakód-olvasást végzünk, majd mechanikus és funkcionális ellenőrzésekkel igazoljuk a feltárt problémát, hogy a javítás valóban tartós megoldást adjon, ne pedig ideiglenes enyhülést.",
      },
      {
        step: "3. Átlátható, tételes árajánlat",
        text: "A munka megkezdése előtt egyértelmű, részletezett árajánlatot adunk, amelyben külön soron szerepel az alkatrész- és a munkadíj. Így pontosan látod, miből áll össze a költség, és nincs utólagos, váratlan meglepetés. Csak azt javítjuk, ami indokolt, és ha van több megoldási lehetőség, azokat is elmondjuk, hogy te hozhasd meg a döntést.",
      },
      {
        step: "4. Minőségi javítás és garancia",
        text: "Bevizsgált, jó minőségű, gyári vagy gyári minőségű alkatrészekkel dolgozunk, és minden javításra írásban vállalt szakmai garanciát adunk. A munka végeztével próbaút következik, hogy meggyőződjünk arról, az autó újra biztonságosan és hibátlanul működik – csak ezután adjuk át a kulcsot.",
      },
    ],
    faqs: [
      {
        q: "Mennyibe kerül egy autószerviz Egerben?",
        a: "Az ár a munka jellegétől függ. Egy átlagos olajcsere és átvizsgálás néhány tízezer forinttól indul, komolyabb javításnál előbb diagnosztikát végzünk, és tételes árajánlatot adunk – csak azt csináljuk meg, amiben előre megegyeztünk.",
      },
      {
        q: "Be kell jelentkezni előre?",
        a: "Igen, kérjük, hogy hívj a +36 30 478 7619 számon, vagy írj az űrlapon. Így ki tudjuk osztani a számodra megfelelő időpontot, és a szükséges alkatrész már a helyszínen lesz.",
      },
      {
        q: "Márkafüggetlen autószervizként minden autót vállaltok?",
        a: "Igen, minden gyakori európai, ázsiai és amerikai személyautó-márkát javítunk Egerben – benzines, dízel és hibrid kivitelben egyaránt.",
      },
      {
        q: "Eger környékéről is fogadtok ügyfeleket?",
        a: "Természetesen. Rendszeresen érkeznek hozzánk autósok Felsőtárkányból, Egerszalókról, Andornaktályáról, Maklárról, Noszvajról és Ostorosról is.",
      },
    ],
    closing:
      "Ha megbízható autószervizt keresel Egerben, ahol a kommunikáció emberi, az árazás átlátható, és a szerelő tényleg elmagyarázza, mi a baj az autóval, a LAKROSZ Autószerviz jó döntés. Hívj minket, és foglalj időpontot – Eger több ezer autósa bízott már ránk eddig is.",
  },
  {
    slug: "fekjavitas-eger",
    cardTitle: "Fékjavítás Eger",
    cardDesc: "Féktárcsa, fékbetét, fékmunkahenger csere, fékpedál vizsgálat Egerben.",
    h1: "Fékjavítás Eger – féktárcsa, fékbetét csere szakszerűen",
    metaTitle: "Fékjavítás Eger | Féktárcsa és fékbetét csere – LAKROSZ",
    metaDescription:
      "Fékjavítás Egerben: féktárcsa, fékbetét, féknyereg csere garanciával. Gyors, megbízható, korrekt ár. LAKROSZ Autószerviz: +36 30 478 7619.",
    image: fekjavitasImg,
    imageAlt: "Fékjavítás Egerben – szerelő féktárcsát cserél a LAKROSZ Autószervizben",
    intro:
      "A fék az autó legfontosabb biztonsági rendszere, ezért a fékjavítást soha nem érdemes halogatni. A LAKROSZ Autószerviz Egerben teljes körű fékrendszer-szervizt biztosít: féktárcsa- és fékbetétcserét, fékmunkahenger- és féknyergek felújítását, fékfolyadékcserét, valamint ABS- és ESP-hibák feltárását. Munkánk során kizárólag bevizsgált, márkás vagy az eredetivel egyenértékű alkatrészeket használunk, mert tudjuk, hogy a fék biztonsági kérdés.",
    symptoms: [
      {
        title: "Csikorgó, fémes hang fékezéskor",
        text: "Általában elhasználódott fékbetétre vagy barázdált féktárcsára utal – minél hamarabb cserélni kell, mielőtt a tárcsa is tönkremegy.",
      },
      {
        title: "Rezgő kormány vagy pedál fékezéskor",
        text: "Deformálódott vagy egyenetlenül kopott féktárcsa tipikus jele, ami csökkenti a fékhatékonyságot.",
      },
      {
        title: "Mélyebbre süllyedő fékpedál",
        text: "Levegős fékrendszerre, fékfolyadék-szivárgásra vagy elhasználódott fékmunkahengerre utalhat – azonnali vizsgálatot igényel.",
      },
      {
        title: "Az autó oldalra húz fékezéskor",
        text: "Beragadt féknyereg, egyenetlen kopás vagy futómű-probléma is állhat a háttérben, ezt diagnosztikával derítjük ki.",
      },
      {
        title: "ABS vagy fékhiba lámpa világít",
        text: "Az ABS-szenzor, kerékagy-csapágy vagy elektronika hibájára utalhat, hibakód-olvasással pontosan beazonosítható.",
      },
    ],
    what: [
      "Első és hátsó fékbetét csere, féktárcsa csere.",
      "Féknyereg felújítás, beragadt fékmunkahenger cseréje.",
      "Fékfolyadék cseréje (DOT 4, DOT 5.1) légtelenítéssel.",
      "ABS-, ESP-rendszerek diagnosztikája és javítása.",
      "Kéziféksaru, kézifékkar és kézifékbowden javítása, beállítása.",
      "Teljes fékrendszer ellenőrzés műszaki vizsga előtt.",
    ],
    workflow: [
      {
        step: "1. Vizsgálat és próbafékezés",
        text: "Először részletesen végigbeszéljük a tapasztalt tüneteket – csikorgás, rezgés, pedál-érzet vagy oldalra húzás –, majd próbafékezéssel és emelőn végzett alapos szemrevételezéssel ellenőrizzük a fékbetétek vastagságát, a féktárcsák állapotát, a féknyergek mozgását és a fékvezetékek épségét. Az ABS- és ESP-rendszert is diagnosztikai műszerrel átvilágítjuk, ha a műszerfalon hibajelzés látható.",
      },
      {
        step: "2. Diagnosztika és tételes árajánlat",
        text: "Ha szükséges, hibakód-olvasást végzünk az elektronikus fékrendszerekben, majd tételes árajánlatot készítünk, amelyben külön feltüntetjük az anyagköltséget és a munkadíjat. A ajánlatban szerepel minden cserére kerülő alkatrész megnevezése, azok minőségi besorolása, és az elvégzendő műveletek sorrendje, hogy teljesen átlátható legyen a folyamat.",
      },
      {
        step: "3. Csere minőségi alkatrészekkel",
        text: "Kizárólag bevizsgált, márkás vagy gyári minőségű féktárcsát, fékbetétet, féknyereg-javító készletet és megfelelő specifikációjú fékfolyadékot építünk be. A szerelés során gondosan tisztítjuk a féknyereg-üléseket, kenjük a csúszófelületeket, és ellenőrizzük a fékcsövek állapotát, hogy a fékrendszer minden eleme hosszú távon megbízhatóan működjön.",
      },
      {
        step: "4. Betanítás, próbaút és átadás",
        text: "Az új fékek gondos betanítása után több féktáv próbafékezést végzünk, majd próbaúton ellenőrizzük, hogy a fékhatás egyenletes, zajmentes, és az autó nem húz oldalra. A munka végeztével átadjuk a cserélt alkatrészek fotóját vagy a régi darabokat, és írásban rögzített garanciát adunk a szerelésre és az alkatrészekre.",
      },
    ],
    faqs: [
      {
        q: "Mikor kell fékbetétet cserélni?",
        a: "Általában 30–60 ezer kilométerenként, de a vezetési stílus és az útviszonyok erősen befolyásolják. Csikorgás, rezgés vagy mélyebbre süllyedő fékpedál esetén mindenképpen ellenőriztesd a fékrendszert Egerben.",
      },
      {
        q: "Féktárcsát mindig fékbetéttel együtt kell cserélni?",
        a: "Nem mindig, de ha a tárcsa kopott a minimum vastagság alá, vagy barázdált, akkor a fékbetéttel együtt érdemes cserélni a tartós, egyenletes fékhatás érdekében.",
      },
      {
        q: "Mennyi idő alatt készültök el a fékjavítással?",
        a: "Egy átlagos fékbetét- és féktárcsacsere általában néhány óra alatt elkészül, így a legtöbb esetben aznap viheted az autót.",
      },
      {
        q: "Adtok garanciát a fékjavításra?",
        a: "Igen, minden beépített alkatrészre és az elvégzett munkára írásban rögzített szakmai garanciát vállalunk.",
      },
    ],
    closing:
      "A fékhibákkal nem szabad várni. Ha az autód furcsán fékez, csikorog, rezeg vagy egyszerűen csak esedékes a féktárcsa- és fékbetétcsere, foglalj nálunk időpontot. A LAKROSZ Autószerviz Egerben gyorsan, szakszerűen és garanciával végzi el a fékjavítást.",
  },
  {
    slug: "futomu-javitas-eger",
    cardTitle: "Futómű javítás Eger",
    cardDesc: "Lengőkar, gömbfej, stabilizátor, csapágy csere és futómű állítás Egerben.",
    h1: "Futómű javítás Eger – lengőkar, gömbfej, csapágy csere",
    metaTitle: "Futómű javítás Eger | Lengőkar, gömbfej, csapágy – LAKROSZ",
    metaDescription:
      "Futómű javítás Egerben: lengőkar, gömbfej, csapágy, kerékbeállítás. Pontosan, megbízhatóan. Hívjon most: +36 30 478 7619.",
    image: futomuImg,
    imageAlt:
      "Futómű javítás Eger – lengőkar, gömbfej, rugó és lengéscsillapító a felemelt autó alatt",
    intro:
      "A futómű felelős azért, hogy az autó stabilan tartsa az irányt, jól lehessen vele kanyarodni, és az abroncsok egyenletesen kopjanak. A LAKROSZ Autószerviz Egerben minden gyakori futómű-javítást elvégzünk: lengőkar-, gömbfej-, stabilizátor-, szilent- és kerékcsapágy-cserét, lengéscsillapító cserét, valamint a futómű komplett átvizsgálását. A rossz futómű nemcsak kényelmetlen, hanem balesetveszélyes és gyorsabb gumikopást is okoz.",
    symptoms: [
      {
        title: "Kattogó, kopogó hang úthibákon",
        text: "Általában elkopott szilent, stabilizátorpálca vagy gömbfej okozza – egyszerűen javítható, ha időben szólsz.",
      },
      {
        title: "A kormány elhúz egyik irányba",
        text: "Rosszul beállított futóműre vagy elhasználódott kerékcsapágyra utalhat, ami egyenletes úton is érezhető.",
      },
      {
        title: "Egyenetlenül kopó gumik",
        text: "Ha a gumi csak az egyik oldalán fogy, szinte biztos, hogy elállítódott a futómű vagy elhasználódott egy alkatrész.",
      },
      {
        title: "Búgó hang gyorsuláskor vagy kanyarban",
        text: "Tipikusan elhasználódott kerékagy-csapágy hangja, ami sebességgel arányosan erősödik.",
      },
      {
        title: "Lágy, bizonytalan menetstabilitás",
        text: "Lehet, hogy a lengéscsillapító elfáradt, és az autó hullámvasútként viselkedik bukkanón és kanyarban.",
      },
    ],
    what: [
      "Lengőkar, gömbfej, szilent, stabilizátorpálca csere.",
      "Első és hátsó kerékcsapágy csere.",
      "Lengéscsillapító és spirálrugó csere.",
      "Kormánymű, kormányösszekötő, nyomtávrúdvég csere.",
      "Futómű állítás (összetartás, dőlés, kormánymegelőzés).",
      "Komplett futómű geometria ellenőrzés és beállítás.",
    ],
    workflow: [
      {
        step: "1. Futómű átvizsgálás emelőn",
        text: "Az autót biztonságosan emelőre tesszük, és szakemberünk alapos szemrevételezéssel, kézzel történő mozgatással és tapintással ellenőrzi az egyes futómű-alkatrészek állapotát. A lengőkarokat, gömbfejeket, stabilizátor-pálcákat, szilenteket és kerékcsapágyakat egyenként megvizsgáljuk, és ha szeretnéd, a kopott darabokat meg is mutatjuk, hogy pontosan lásd, miért indokolt a csere.",
      },
      {
        step: "2. Tételes árajánlat",
        text: "Csak azt cseréljük, ami valóban indokolt – a feleslegest nem erőltetjük, és ezt írásban, tételesen meg is mutatjuk. Az árajánlatban külön szerepel minden alkatrész megnevezése, minősége és ára, valamint a munkadíj, így te döntheted el, mely javításokat végezzük el most, és melyek halaszthatók egy későbbi időpontra anélkül, hogy veszélybe sodornánk a menetbiztonságot.",
      },
      {
        step: "3. Csere és próbaút",
        text: "A kopott alkatrészeket precízen, gyári szerszámokkal cseréljük, majd minden csavarkötést nyomatékkulccsal húzunk meg a gyári értékeknek megfelelően. Ezután próbaúton ellenőrizzük, hogy a korábban tapasztalt kattogás, rezgés vagy oldalra húzás teljesen megszűnt-e, és az autó ismét stabilan, kényelmesen vezethető.",
      },
      {
        step: "4. Futómű állítás szükség esetén",
        text: "Ha a javítás indokolja – például lengőkar- vagy kormányalkatrész-csere után –, a futómű geometriát is precíz műszerekkel beállítjuk. Az összetartást, dőlést és kormánymegelőzést a gyári toleranciákra hangoljuk, hogy a gumik egyenletesen kopjanak, a kormányzás közvetlen legyen, és az autó egyenesen haladjon anélkül, hogy folyton korrigálni kellene.",
      },
    ],
    faqs: [
      {
        q: "Mikor szükséges futómű javítás?",
        a: "Ha az autó kanyarodáskor kattog, úthibákon kopog, oldalra húz, vagy a gumi egyenetlenül kopik, érdemes futómű-átvizsgálást kérni. Sok hibát olcsóbb időben javítani, mielőtt másra is átterhelődne.",
      },
      {
        q: "Milyen gyakran kell futóművet állítani?",
        a: "Évente egyszer, valamint minden olyan munka után, amely érinti a futómű geometriáját – például lengőkar-, gömbfej- vagy kormányalkatrész-csere után.",
      },
      {
        q: "Mennyi ideig tart a futómű állítás Egerben?",
        a: "A komplett geometria ellenőrzés és beállítás általában 1–2 óra, az autó típusától és állapotától függően.",
      },
      {
        q: "Eger környékéről is mehetek hozzátok futómű javításra?",
        a: "Igen, rendszeresen javítunk futóművet Felsőtárkány, Egerszalók, Andornaktálya, Maklár, Noszvaj és Ostoros környékéről érkező ügyfeleinknek is.",
      },
    ],
    closing:
      "Ha az autód kattog, ugrál, vagy bizonytalanul tartja az irányt, hozd be a LAKROSZ Autószervizbe Egerben. Megnézzük, megmutatjuk, és csak azt javítjuk, ami tényleg szükséges – tisztességes áron, garanciával.",
  },
  {
    slug: "motorfelujitas-eger",
    cardTitle: "Motorfelújítás Eger",
    cardDesc: "Teljes motorfelújítás, hengerfej felújítás, vezérlés csere Egerben.",
    h1: "Motorfelújítás Eger – teljes motorfelújítás szakszerűen",
    metaTitle: "Motorfelújítás Eger | Hengerfej, vezérlés, blokk – LAKROSZ",
    metaDescription:
      "Motorfelújítás Egerben: hengerfej, tömítés, vezérlés csere. Részleges és teljes felújítás. LAKROSZ Autószerviz, Eger.",
    image: motorfelujitasImg,
    imageAlt:
      "Motorfelújítás Eger – benzinmotor szívósorral és motortér közelről a LAKROSZ Autószervizben",
    intro:
      "A motorfelújítás komoly, sokrétű munka, amit csak tapasztalt műhelyre érdemes bízni. A LAKROSZ Autószerviz Egerben évek óta végez teljes és részleges motorfelújítást személyautókra: hengerfej-felújítást, vezérlés- és vízpumpa-cserét, tömítés- és olajteknő-tömítés cserét, valamint komplett blokkfelújítást. Hosszú távú megoldást keresünk, ami nem fél év múlva újra a hibakód-olvasón végzi.",
    symptoms: [
      {
        title: "Kék vagy fehér füst a kipufogóból",
        text: "Olajégésre vagy hűtőfolyadék-szivárgásra utal – tipikusan kopott szelepszár-tömítés, hengerfejtömítés vagy dugattyúgyűrű a hiba forrása.",
      },
      {
        title: "Hűtőfolyadék fogy, de nincs látható szivárgás",
        text: "Belső szivárgás, gyakran sérült hengerfejtömítés vagy repedt hengerfej, ami komoly motorkárt okozhat, ha nem kezelik.",
      },
      {
        title: "Motorkopogás, kattogás hidegen vagy melegen",
        text: "Vezérlési probléma, kopott hidraulikus emelő, vagy súlyosabb esetben elhasználódott főtengelycsapágy lehet a háttérben.",
      },
      {
        title: "Olajnyomás kijelző bevillan",
        text: "Olajszivattyú hibára, eltömődött olajszűrőre vagy kopott csapágyakra utal – ilyenkor azonnal meg kell állni.",
      },
      {
        title: "Rángatás, teljesítményvesztés",
        text: "Lehet befecskendező, EGR, turbó vagy mechanikus motorhiba – pontos diagnosztikával derítjük ki.",
      },
    ],
    what: [
      "Teljes motorfelújítás (blokk, hengerfej, vezérlés, tömítések).",
      "Hengerfej-felújítás: planírozás, szelepcsiszolás, szelepszár-tömítés csere.",
      "Vezérlés- (szíj vagy lánc), vízpumpa- és feszítő csere.",
      "Hengerfejtömítés és olajteknő-tömítés csere.",
      "Turbófeltöltő javítás, csere, beépítés.",
      "EGR, DPF, befecskendező hibák feltárása és javítása.",
    ],
    workflow: [
      {
        step: "1. Pontos állapotfelmérés",
        text: "Kompressziómérés, olajnyomás-teszt, hibakód-olvasás és hűtőrendszer-nyomáspróba segítségével pontos képet kapunk a motor belső állapotáról. A hengerfejtömítés épségét, a dugattyúgyűrűk kopását és a szelepek zárását is ellenőrizzük, mielőtt bármilyen árat mondanánk – így elkerüljük az utólagos meglepetéseket és a felesleges szétszerelést.",
      },
      {
        step: "2. Részletes árajánlat",
        text: "Külön bontva szerepel az árajánlatban az alkatrész- és a munkadíj, valamint megmutatjuk, mi az, ami most kötelező a motor megbízható működéséhez, és mi az, ami későbbi ütemben, kisebb ráfordítással is elvégezhető. Így te döntheted el, milyen mélységű felújítást szeretnél, és mi illik az autó értékéhez, valamint a tervezett használathoz.",
      },
      {
        step: "3. Szakszerű szétszerelés és felújítás",
        text: "A motort gondosan, szabályos sorrendben szétszereljük, minden alkatrészt kitisztítunk és méretezünk. Csak minőségi, gyári vagy gyári minőségű alkatrészekkel és tömítésekkel dolgozunk, a hengerfejet szükség szerint planíroztatjuk, a szelepeket csiszoltatjuk, és a dugattyúgyűrűket a gyári hézagoknak megfelelően építjük be, hogy a motor hosszú évekig hibátlanul járjon.",
      },
      {
        step: "4. Bejáratás, olajcsere és garancia",
        text: "Összeszerelés után gondos, fokozatos bejáratást végzünk, amely során ellenőrizzük a hőmérsékleteket, nyomásokat és a szivárgásmentességet. Az első futásteljesítmény elérése után lecseréljük a bejárató olajat, és az autót próbaúton is leteszteljük. A munkára és az alkatrészekre írásban vállalt garanciát adunk, hogy biztos lehess a felújítás minőségében.",
      },
    ],
    faqs: [
      {
        q: "Megéri felújítani a motort, vagy inkább cseréljem?",
        a: "Mindig az autó értéke és állapota dönti el. Diagnosztika után őszintén megmondjuk, érdemes-e felújítani, vagy más megoldás (csere motor, eladás) jobb döntés lehet.",
      },
      {
        q: "Mennyi idő alatt készültök el egy motorfelújítással?",
        a: "A munka mélységétől függ: egy hengerfej-felújítás néhány nap, egy teljes blokkfelújítás 1–3 hét – az alkatrész-beszerzéssel együtt.",
      },
      {
        q: "Milyen garanciát vállaltok a motorfelújításra?",
        a: "A beépített alkatrészekre és az elvégzett munkára írásban rögzített szakmai garanciát adunk, a felújítás típusától függő időtartammal.",
      },
      {
        q: "Vezérlésszíj vagy láncos vezérlés cseréjét is vállaljátok?",
        a: "Igen, mindkettőt: a vezérléscserét a vízpumpa és a feszítő egyidejű cseréjével végezzük, hogy a teljes rendszer együtt induljon új ciklusra.",
      },
    ],
    closing:
      "A motorfelújítás nem az a munka, amit a legolcsóbbnál kell elvégeztetni. Ha hosszú távra szeretnél megoldást, hozd be az autót a LAKROSZ Autószervizbe Egerben – őszintén megmondjuk, érdemes-e felújítani, vagy más megoldás éri meg jobban.",
  },
  {
    slug: "muszaki-vizsga-felkeszites-eger",
    cardTitle: "Műszaki vizsga felkészítés Eger",
    cardDesc: "Műszaki vizsga előtti átvizsgálás, hibák javítása, vizsgára kísérés Egerben.",
    h1: "Műszaki vizsga felkészítés Eger – alapos átvizsgálás, szakszerű javítás",
    metaTitle: "Műszaki vizsga felkészítés Egerben | LAKROSZ Autószerviz",
    metaDescription:
      "Műszaki vizsga felkészítés Egerben. Átvizsgálás, hibák javítása, vizsgára kísérés. Első nekifutásra átmenni — ez a cél.",
    image: muszakiVizsgaImg,
    imageAlt:
      "Műszaki vizsga felkészítés Eger – szerelő diagnosztikai műszerrel ellenőrzi az autót",
    intro:
      "A műszaki vizsga sok autósnak feszültséget okoz, főleg ha nem tudja, mi várható. A LAKROSZ Autószerviz Egerben teljes körű műszaki vizsga felkészítést végez: alaposan átvizsgáljuk az autót, listázzuk a hibákat, megjavítjuk, ami szükséges, és igény szerint a vizsgára is elkísérjük. Cél, hogy elsőre, biztosan átmenj a vizsgán – ne legyen ismételt vizsgadíj, ne kelljen újra szabadnapot kivenni.",
    symptoms: [
      {
        title: "Műszerfali hibajelzések, lámpák",
        text: "Bármely világító hibalámpa (motor, ABS, légzsák, ESP) automatikus elbukást jelent a műszaki vizsgán.",
      },
      {
        title: "Olaj-, hűtőfolyadék-szivárgás",
        text: "A vizsgálóbiztos visszaadja az autót, ha a motortérben vagy alvázon friss szivárgás látható.",
      },
      {
        title: "Kopott gumi, repedt szélvédő",
        text: "1,6 mm alatti profilmélység, vagy a látómezőben lévő szélvédőrepedés tipikus vizsgabukási ok.",
      },
      {
        title: "Nem világító lámpa, kopott fékbetét",
        text: "Egy izzó kiégése vagy a fékbetét vékonysága is megbuktathat – ezeket apró tételért előre javítjuk.",
      },
      {
        title: "Kipufogó, emisszió problémák",
        text: "Lyukas kipufogó, magas CO/HM érték javítás nélkül szinte garantáltan vizsgabukást eredményez.",
      },
    ],
    what: [
      "Műszaki vizsga előtti teljes átvizsgálás (fékek, futómű, világítás, kipufogó, gumik, szélvédő, karosszéria).",
      "Hibalista készítése, ár- és prioritásrendezéssel.",
      "Szükséges javítások elvégzése egy helyen.",
      "Emisszióvizsgálatra (CO/füstölés) felkészítés.",
      "Vizsgára kísérés egyeztetés szerint.",
      "Eredetiségvizsgálathoz előkészítés.",
    ],
    workflow: [
      {
        step: "1. Előzetes, teljes körű átvizsgálás",
        text: "Az autót biztonságosan emelőre tesszük, és tapasztalt szerelőnk a vizsgálóbiztos szemével, szigorúan a jogszabályi előírásoknak megfelelően nézi végig az járművet. Ellenőrizzük a fékrendszer hatékonyságát és állapotát, a futómű alkatrészeinek kopását, a kipufogórendszer épségét, a világítóberendezések működését, a gumiabroncsok profilmélységét és a szélvédő sérüléseit is, hogy semmilyen buktató pont ne maradjon rejtve.",
      },
      {
        step: "2. Hibalista és tételes árajánlat",
        text: "Megmutatjuk, mi az, ami a vizsgán biztosan megbuktatna, és mi az, ami csak ajánlott karbantartási tétel. Az árajánlatban tételesen feltüntetjük minden javítás anyag- és munkadíját, így te döntheted el, hogy mely munkálatokat végezzük el most, és melyeket halaszthatod a vizsga utánra – mindezt azért, hogy ne kelljen kétszer fizetned a vizsgadíjat.",
      },
      {
        step: "3. Javítás és újraellenőrzés",
        text: "Elvégezzük a szükséges javításokat – legyen szó fékbetét-cseréről, izzócseréről, kipufogó-javításról vagy futómű-beállításról –, majd a munka befejeztével újra, teljes körűen végigmegyünk a vizsgapontokon. Csak akkor adjuk át az autót a vizsgára, ha mi magunk is százszázalékosan meg vagyunk győződve arról, hogy minden paraméter megfelel a hatósági előírásoknak.",
      },
      {
        step: "4. Vizsgára kísérés és átadás",
        text: "Igény szerint a vizsgaállomásra is elvisszük az autót, ahol személyesen intézzük az átadást és a szükséges adminisztrációt, te pedig csak az új, érvényes vizsgamatricáért és a papírokért jössz. Ha bármilyen kérdés merül fel a vizsgán, ott helyben rendelkezésre állunk, hogy a lehető leggördülékenyebben és leggyorsabban lezáruljon az egész folyamat.",
      },
    ],
    faqs: [
      {
        q: "Segítetek műszaki vizsga előtt átnézni az autót?",
        a: "Igen, ez az egyik legkeresettebb szolgáltatásunk Egerben: a vizsgapontok mentén alaposan átnézzük az autót, és listázzuk, mi javítandó. Ezzel jelentősen csökkentjük a bukás kockázatát.",
      },
      {
        q: "Mennyivel a vizsga előtt vigyem be az autót?",
        a: "Általában 1–2 héttel a tervezett vizsga előtt érdemes hozni, hogy legyen idő az esetleges javításokra és alkatrész-beszerzésre.",
      },
      {
        q: "Vizsgára is elkísértek?",
        a: "Igen, igény szerint a vizsgaállomásra is elvisszük az autót, és személyesen intézzük az átadást, hogy neked csak az új matricáért kelljen jönnöd.",
      },
      {
        q: "Mit kezdjek, ha valami a vizsgán mégis hibát mutat?",
        a: "Ilyen esetben azonnal javítjuk a feltárt hibát, és igyekszünk minél hamarabb visszavinni az autót pótvizsgára – minimalizálva a kiesett napokat.",
      },
    ],
    closing:
      "Ne kockáztass kétszeres vizsgadíjat: a LAKROSZ Autószerviz Egerben alaposan felkészíti az autód a műszaki vizsgára, hogy jó eséllyel elsőre megfeleljen, és csak azt javítjuk, ami valóban szükséges. Foglalj időpontot most, és intézzünk mindent egy helyen.",
  },
  {
    slug: "gumiszereles-eger",
    cardTitle: "Gumiszerelés Eger",
    cardDesc:
      "Nyári és téli gumicsere, centrírozás, szelepcsere és pontos guminyomás-beállítás Egerben.",
    h1: "Gumiszerelés Eger – gumicsere és centrírozás",
    metaTitle: "Gumiszerelés Eger | LAKROSZ Autószerviz",
    metaDescription:
      "Gumiszerelés és centrírozás Egerben. Nyári és téli gumicsere, kerékegyensúlyozás, Continental, Michelin, Pirelli. Időpontfoglalás: +36 30 478 7619.",
    intro:
      "A megfelelő állapotú és pontosan kiegyensúlyozott gumiabroncs alapvető a biztonságos fékezéshez, a stabil kanyarodáshoz és az egyenletes kopáshoz. Egeri műhelyünkben nyári és téli kerékcserét, szakszerű gumiszerelést, centrírozást, szelepcserét és guminyomás-beállítást végzünk. Az autó használatához, méretéhez és a tervezett futásteljesítményhez illő abroncs kiválasztásában is segítünk, többek között Continental, Michelin, Hankook és Pirelli kínálatból.",
    image: gumiszerelesImg,
    imageAlt:
      "Gumiszerelés és centrírozás Egerben – téli gumiabroncsok a LAKROSZ Autószerviz műhelyében",
    symptomsTitle: "Mikor van szükség gumiszerelésre?",
    symptoms: [
      {
        title: "Elérkezett a szezonális gumicsere ideje",
        text: "Tartósan 7 °C alatti hőmérsékletnél téli, melegebb időben nyári abroncs biztosít megfelelő tapadást és fékutat.",
      },
      {
        title: "Ráz a kormány vagy vibrál az autó",
        text: "A sebességgel erősödő rezgés gyakran kiegyensúlyozatlan kerékre utal, amit precíz centrírozással lehet megszüntetni.",
      },
      {
        title: "Egyenetlen vagy túlzott a kopás",
        text: "A féloldalas, kagylós vagy középen jelentkező kopás helytelen nyomást, futóműhibát vagy rossz kerékegyensúlyt jelezhet.",
      },
      {
        title: "Sérült az abroncs vagy lassan ereszt",
        text: "Szög, repedés, dudor, sérült szelep vagy tömítetlenség esetén az abroncsot mielőbb át kell vizsgálni a biztonságos javíthatóság megállapításához.",
      },
    ],
    whatTitle: "Mit végzünk el",
    what: [
      "Nyári és téli gumiabroncsok szakszerű le- és felszerelése.",
      "Kerékcentrírozás és kerékegyensúlyozás korszerű műszerrel.",
      "Szelepcsere, szelepellenőrzés és szükség esetén új szelepmag beépítése.",
      "A gyári előírásnak megfelelő guminyomás beállítása és ellenőrzése.",
      "Abroncsállapot, profilmélység, oldalfal és futófelület vizsgálata.",
      "Continental, Michelin, Hankook és Pirelli abroncsok kiválasztása és beszerzése.",
    ],
    workflow: [
      {
        step: "1. Állapotfelmérés és igényegyeztetés",
        text: "Megnézzük az abroncsok méretét, korát, profilmélységét és sérüléseit, majd egyeztetjük az autó használatát és a várható futásteljesítményt. Ha új garnitúrára van szükség, több megbízható lehetőséget ajánlunk a megfelelő méretben és terhelési indexszel.",
      },
      {
        step: "2. Szakszerű kerék- és gumiszerelés",
        text: "A kerekeket az előírt emelési pontokon vesszük le, az abroncsot a felni sérülése nélkül szereljük át, közben megtisztítjuk a felfekvő felületeket és ellenőrizzük a szelepet. A forgásirányos és aszimmetrikus abroncsokat mindig a jelölésüknek megfelelően építjük fel.",
      },
      {
        step: "3. Precíz centrírozás és nyomásbeállítás",
        text: "Minden kereket külön kiegyensúlyozunk, a szükséges súlyokat pontosan elhelyezzük, majd a guminyomást az autó gyári értékére állítjuk. Ezzel csökkenthető a kormányrezgés, az egyenetlen kopás és a futómű felesleges terhelése.",
      },
      {
        step: "4. Végellenőrzés és biztonságos átadás",
        text: "A kerékcsavarokat nyomatékkulccsal, gyári értékre húzzuk meg, ellenőrizzük a tömítettséget és átbeszéljük az abroncsok várható élettartamát. Jelezzük azt is, ha futómű-ellenőrzés vagy rövid időn belüli utánállítás indokolt.",
      },
    ],
    faqs: [
      {
        q: "Mikor érdemes nyári vagy téli gumira váltani?",
        a: "Nem egyetlen dátum, hanem a tartós hőmérséklet számít: 7 °C alatt a téli, fölötte a nyári abroncs nyújt kedvezőbb tapadást és kopást.",
      },
      {
        q: "Mennyi ideig tart egy teljes gumicsere és centrírozás?",
        a: "Egy átlagos személyautó négy kerekének szerelése és centrírozása rendszerint 45–90 perc, az abroncs és a felni állapotától függően.",
      },
      {
        q: "Új abroncs beszerzésében is segítetek?",
        a: "Igen. Az autó mérete, használata és a tervezett keret alapján Continental, Michelin, Hankook, Pirelli és más bevált gyártók kínálatából ajánlunk megfelelő abroncsot.",
      },
      {
        q: "A gumiszerelés után futóműállítás is szükséges?",
        a: "Nem minden esetben, de féloldalas kopás, oldalra húzás vagy futóműjavítás után mindenképpen javasolt a geometria ellenőrzése és pontos beállítása.",
      },
    ],
    closing:
      "Ne várd meg a szezon első havazását vagy a nyári indulás előtti utolsó napot. Foglalj időpontot gumiszerelésre Egerben: gyorsan, pontosan és az abroncsok állapotáról őszintén tájékoztatva adjuk vissza az autódat.",
    relatedServiceSlugs: [
      "fekjavitas-eger",
      "futomu-javitas-eger",
      "motorkerekpar-szerviz-eger",
      "autoszerviz-eger",
    ],
  },
  {
    slug: "motorkerekpar-szerviz-eger",
    cardTitle: "Motorkerékpár szerviz Eger",
    cardDesc:
      "Közúti és versenypályás motorkerékpárok karbantartása, hibafeltárása és felkészítése Egerben.",
    h1: "Motorkerékpár szerviz Eger – közúti és pályamotorok",
    metaTitle: "Motorkerékpár szerviz Eger | LAKROSZ",
    metaDescription:
      "Motorkerékpár szerviz Egerben versenypályás tapasztalattal. Nagy Krisztián: Alpok-Adria, Supersport VB. +36 30 478 7619",
    intro:
      "A motorkerékpár karbantartásánál minden beállítás közvetlenül hat a vezethetőségre és a biztonságra. A LAKROSZ egeri műhelyében utcai, túra- és sportmotorok átvizsgálását, időszakos szervizét, fék-, futómű-, hajtás- és motorjavítását vállaljuk. Nagy Krisztián Alpok-Adria és Supersport világbajnoki tapasztalata a versenypályán szerzett precizitást hozza el a közúti motorok szervizelésébe is.",
    image: motorkerekparImg,
    imageAlt:
      "Motorkerékpár szerviz Egerben – sportmotor professzionális szervizemelőn a műhelyben",
    symptomsTitle: "Mikor érdemes motorkerékpár-szervizt kérni?",
    symptoms: [
      {
        title: "Bizonytalan irányíthatóság vagy szokatlan rezgés",
        text: "A kormány, a futómű, a kerékcsapágy vagy a gumi hibája már kis eltérésnél is érezhető, ezért célzott ellenőrzést igényel.",
      },
      {
        title: "Gyenge vagy egyenetlen fékhatás",
        text: "A puha fékkar, pulzálás, csikorgás vagy hosszabb fékút a fékbetét, féktárcsa, folyadék vagy féknyereg vizsgálatát indokolja.",
      },
      {
        title: "Rángat a hajtás vagy zajos a lánc",
        text: "A helytelen láncfeszesség, kopott láncszett vagy elállított hátsó kerék rontja a gázreakciót és veszélyes alkatrészkárosodást okozhat.",
      },
      {
        title: "Esedékes az időszakos vagy szezon előtti szerviz",
        text: "Olaj-, szűrő- és folyadékcsere, akkumulátor-, gumi- és világításellenőrzés után kiszámíthatóbban és biztonságosabban indulhat a szezon.",
      },
    ],
    whatTitle: "Mit végzünk el",
    what: [
      "Időszakos karbantartás, motorolaj-, szűrő-, gyertya- és folyadékcsere.",
      "Fékrendszer ellenőrzése, fékbetét- és fékfolyadékcsere, féknyereg-karbantartás.",
      "Lánc és lánckerekek ellenőrzése, tisztítása, beállítása és cseréje.",
      "Futómű, kormánycsapágy, kerékcsapágy és lengéscsillapítás vizsgálata.",
      "Elektronikai hibafeltárás, akkumulátor- és töltésrendszer-ellenőrzés.",
      "Közúti, túra- és versenypályás használatra történő műszaki felkészítés.",
    ],
    workflow: [
      {
        step: "1. Beszélgetés és részletes állapotfelmérés",
        text: "Átbeszéljük a motor előéletét, használatát, az utolsó szerviz idejét és a tapasztalt tüneteket. Ezután emelőn, pontról pontra ellenőrizzük a féket, futóművet, kormányzást, hajtást, gumikat, folyadékszinteket és az elektromos rendszert.",
      },
      {
        step: "2. Diagnosztika és átlátható javaslat",
        text: "A mechanikai vizsgálatot szükség esetén műszeres diagnosztikával egészítjük ki. Külön választjuk a biztonság szempontjából azonnal szükséges munkákat a tervezhető karbantartástól, majd tételes ajánlatot adunk az alkatrészekre és a munkadíjra.",
      },
      {
        step: "3. Precíz javítás és beállítás",
        text: "A jóváhagyott munkákat a gyártói előírások, meghúzási nyomatékok és folyadékspecifikációk szerint végezzük el. Kiemelten figyelünk a fék, a futómű és a hajtás pontos beállítására, mert motorkerékpáron ezek kis eltérése is azonnal érezhető.",
      },
      {
        step: "4. Végellenőrzés és átadás",
        text: "A szerelés után újra ellenőrizzük minden megbontott kötés, folyadékszint és biztonsági elem állapotát, majd funkciópróbát végzünk. Átadáskor elmondjuk, milyen munkák készültek el, mire figyelj az első kilométereken, és mikor esedékes a következő ellenőrzés.",
      },
    ],
    faqs: [
      {
        q: "Milyen motorkerékpárokat vállaltok?",
        a: "Utcai, túra- és sportmotorok időszakos karbantartását, hibafeltárását és javítását vállaljuk. Időpont-egyeztetéskor kérjük a márkát, típust, évjáratot és a tapasztalt hibát.",
      },
      {
        q: "Versenypályás felkészítést is végeztek?",
        a: "Igen. Nagy Krisztián Alpok-Adria és Supersport világbajnoki tapasztalatára építve a fék, futómű, hajtás és biztonsági pontok célzott ellenőrzését, valamint a pályahasználathoz szükséges műszaki felkészítést is vállaljuk.",
      },
      {
        q: "Szezon előtt mit érdemes ellenőriztetni?",
        a: "Legalább az olajat, fékfolyadékot, fékbetéteket, gumikat, láncszettet, akkumulátort, töltést, világítást és a futómű állapotát. Hosszabb állás után a folyadékszivárgásokat is átnézzük.",
      },
      {
        q: "Kell előre időpontot foglalni?",
        a: "Igen, így fel tudunk készülni a motor típusára és a várható alkatrészigényre. Hívj a +36 30 478 7619 számon, és egyeztetünk egy tartható időpontot.",
      },
    ],
    closing:
      "Akár a mindennapi közlekedéshez, egy hosszú túrához vagy versenypályás naphoz szeretnéd felkészíteni a motorodat, foglalj időpontot a LAKROSZ motorkerékpár-szervizébe Egerben. A célunk nemcsak a hiba megszüntetése, hanem a pontos, kiszámítható és biztonságos működés.",
    relatedServiceSlugs: [
      "fekjavitas-eger",
      "futomu-javitas-eger",
      "gumiszereles-eger",
      "autoszerviz-eger",
    ],
  },
];
